import { type FC } from 'react';

import EditOffOutlinedIcon from '@mui/icons-material/EditOffOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import type { CheckboxRenderProps } from '../../viewOption/types.ts';

import { CheckboxRender } from './CheckboxRenderer.tsx';
import styled from 'styled-components';

export const PenCheckboxRender: FC<CheckboxRenderProps> = (props) => {
  return (
    <CheckboxRender
      {...props}
      mixedComponent={<MixedComponent />}
      checkedComponent={<EditOutlinedIcon />}
      uncheckedComponent={<EditOffOutlinedIcon />}
    />
  );
};

const MixedComponent = styled(EditTwoToneIcon)`
  color: ${({ theme }): string => theme.customPalette.panels.side.font};
`;
